import ROUTES from 'constants/routes';

import { CustomTimeType, Option, Time, TimeFrame } from './types';

export const DEFAULT_TIME_RANGE = '30m';

export const Options: Option[] = [
	{ value: '5m', label: 'Last 5 minutes' },
	{ value: '15m', label: 'Last 15 minutes' },
	{ value: '30m', label: 'Last 30 minutes' },
	{ value: '1h', label: 'Last 1 hour' },
	{ value: '6h', label: 'Last 6 hours' },
	{ value: '1d', label: 'Last 1 day' },
	{ value: '3d', label: 'Last 3 days' },
	{ value: '1w', label: 'Last 1 week' },
	{ value: '1month', label: 'Last 1 month' },
	{ value: 'custom', label: 'Custom Date Range' },
];

export const RelativeTimeMap: TimeFrame = {
	'5min': '5m',
	'15min': '15m',
	'30min': '30m',
	'1hr': '1h',
	'6hr': '6h',
	'1day': '1d',
	'3days': '3d',
	'1week': '1w',
};

export const OLD_RELATIVE_TIME_VALUES = [
	'1min',
	'10min',
	'15min',
	'1hr',
	'30min',
	'45min',
	'5min',
	'1day',
	'3days',
	'4days',
	'10days',
	'1week',
	'2weeks',
	'6weeks',
	'3hr',
	'4hr',
	'6hr',
	'12hr',
];

export const RelativeDurationOptions: Option[] = [
	{ value: '5m', label: 'Last 5 minutes' },
	{ value: '15m', label: 'Last 15 minutes' },
	{ value: '30m', label: 'Last 30 minutes' },
	{ value: '1h', label: 'Last 1 hour' },
	{ value: '6h', label: 'Last 6 hour' },
	{ value: '1d', label: 'Last 1 day' },
	{ value: '3d', label: 'Last 3 days' },
	{ value: '1w', label: 'Last 1 week' },
	{ value: '1month', label: 'Last 1 month' },
];

export const RelativeDurationSuggestionOptions: Option[] = [
	{ value: '3h', label: 'Last 3 hours' },
	{ value: '4d', label: 'Last 4 days' },
	{ value: '6w', label: 'Last 6 weeks' },
	{ value: '12h', label: 'Last 12 hours' },
	{ value: '10d', label: 'Last 10 days' },
	{ value: '2w', label: 'Last 2 weeks' },
	{ value: '2months', label: 'Last 2 months' },
	{ value: '1d', label: 'today' },
];
export const FixedDurationSuggestionOptions: Option[] = [
	{ value: '45m', label: 'Last 45 mins' },
	{ value: '12h', label: 'Last 12 hours' },
	{ value: '10d', label: 'Last 10 days' },
	{ value: '2w', label: 'Last 2 weeks' },
	{ value: '2months', label: 'Last 2 months' },
	{ value: '1d', label: 'today' },
];

export const convertOldTimeToNewValidCustomTimeFormat = (
	time: string,
): CustomTimeType => {
	const regex = /^(\d+)([a-zA-Z]+)/;
	const match = regex.exec(time);

	if (match) {
		let unit = 'm';

		switch (match[2]) {
			case 'min':
				unit = 'm';
				break;
			case 'hr':
				unit = 'h';
				break;
			case 'day':
			case 'days':
				unit = 'd';
				break;
			case 'week':
			case 'weeks':
				unit = 'w';
				break;

			default:
				break;
		}

		return `${match[1]}${unit}` as CustomTimeType;
	}

	return DEFAULT_TIME_RANGE;
};

export const getDefaultOption = (route: string): Time => {
	if (route === ROUTES.SERVICE_MAP) {
		return RelativeDurationOptions[2].value;
	}
	if (route === ROUTES.APPLICATION) {
		return Options[2].value;
	}

	if (route === ROUTES.METER) {
		return Options[5].value;
	}
	return Options[2].value;
};

export const getOptions = (routes: string): Option[] => {
	if (routes === ROUTES.SERVICE_MAP) {
		return RelativeDurationOptions;
	}
	return Options;
};

export const routesToHideBreadCrumbs = [ROUTES.SUPPORT, ROUTES.ALL_DASHBOARD];

export const routesToSkip = [
	ROUTES.HOME,
	ROUTES.SETTINGS,
	ROUTES.LIST_ALL_ALERT,
	ROUTES.TRACE_DETAIL,
	ROUTES.ALL_CHANNELS,
	ROUTES.USAGE_EXPLORER,
	ROUTES.GET_STARTED_WITH_CLOUD,
	ROUTES.VERSION,
	ROUTES.ALL_DASHBOARD,
	ROUTES.ORG_SETTINGS,
	ROUTES.MEMBERS_SETTINGS,
	ROUTES.SERVICE_ACCOUNTS_SETTINGS,
	ROUTES.MCP_SERVER,
	ROUTES.INGESTION_SETTINGS,
	ROUTES.ERROR_DETAIL,
	ROUTES.LOGS_PIPELINES,
	ROUTES.BILLING,
	ROUTES.ROLES_SETTINGS,
	ROUTES.ROLE_DETAILS,
	ROUTES.ROLE_CREATE,
	ROUTES.ROLE_EDIT,
	ROUTES.SUPPORT,
	ROUTES.WORKSPACE_LOCKED,
	ROUTES.WORKSPACE_SUSPENDED,
	ROUTES.LOGS,
	ROUTES.MY_SETTINGS,
	ROUTES.LIST_LICENSES,
	ROUTES.LOGS_SAVE_VIEWS,
	ROUTES.LOGS_PIPELINES,
	ROUTES.TRACES_EXPLORER,
	ROUTES.TRACES_SAVE_VIEWS,
	ROUTES.TRACES_FUNNELS,
	ROUTES.TRACES_FUNNELS_DETAIL,
	ROUTES.SHORTCUTS,
	ROUTES.INTEGRATIONS,
	ROUTES.INTEGRATIONS_DETAIL,
	ROUTES.DASHBOARD,
	ROUTES.SERVICE_TOP_LEVEL_OPERATIONS,
	ROUTES.ALERT_HISTORY,
	ROUTES.ALERT_OVERVIEW,
	ROUTES.MESSAGING_QUEUES_KAFKA,
	ROUTES.MESSAGING_QUEUES_KAFKA_DETAIL,
	ROUTES.MESSAGING_QUEUES_CELERY_TASK,
	ROUTES.MESSAGING_QUEUES_OVERVIEW,
	ROUTES.INFRASTRUCTURE_MONITORING_HOSTS,
	ROUTES.SOMETHING_WENT_WRONG,
	ROUTES.INFRASTRUCTURE_MONITORING_KUBERNETES,
	ROUTES.METRICS_EXPLORER,
	ROUTES.METRICS_EXPLORER_EXPLORER,
	ROUTES.METRICS_EXPLORER_VIEWS,
	ROUTES.API_MONITORING,
	ROUTES.CHANNELS_NEW,
	ROUTES.CHANNELS_EDIT,
	ROUTES.WORKSPACE_ACCESS_RESTRICTED,
	ROUTES.ALL_ERROR,
	ROUTES.UN_AUTHORIZED,
	ROUTES.NOT_FOUND,
	ROUTES.METER_EXPLORER,
	ROUTES.METER,
	ROUTES.METER_EXPLORER_VIEWS,
	ROUTES.METRICS_EXPLORER_VOLUME_CONTROL,
	ROUTES.SOMETHING_WENT_WRONG,
	ROUTES.AI_OBSERVABILITY_OVERVIEW,
	ROUTES.AI_OBSERVABILITY_CONFIGURATION,
	ROUTES.AI_OBSERVABILITY_ATTRIBUTE_MAPPING,
	ROUTES.AI_OBSERVABILITY_EXPLORER,
];

export const routesToDisable = [ROUTES.LOGS_EXPLORER, ROUTES.LIVE_LOGS];
